<template>
  <div class="card">
    <div class="card-body pb-0 pt-2">
      <div class="row">
        <div class="col-12 text-left" >
          <slot name="card-title"></slot>
        </div>
        <div class="col-12 box-center">
          <div class="text-center" style="transform: translateX(25%)">
            <slot name="card-value"><span class="no-value ">-</span></slot>
          </div>
          <div class="text-right percentage">
            <slot name="card-percentage"></slot>
          </div>
        </div>  
      </div>
      <slot name="card-report-list"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportCard",
  data() {
    return {};
  }
};
</script>

<style scoped>
.percentage{
  margin-top: auto;
    margin-bottom: 0.85rem;
    transform: translateX(50%);
    margin-left: 5px;
}
.box-center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  min-height: 68px;
  height: 100%;
  cursor: pointer;
  border-radius: 12px;
}
.card-body {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  margin-top: 40px;
}
.card-body .opacity-80 {
  opacity: 0.8;
}
.card-body .opacity-70 {
  opacity: 0.7;
}
.card-body .no-value {
  font-size: 2.12rem;
  color: #cccccc;
  font-weight: 700;
}
.card-body .report-card-title {
  font-size: 1rem;
  font-family: "Open Sans", sans-serif;
  color: #7c828a;

}
.card-body .report-card-value {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.37rem;
  color: var(--main-color);
}
.card-body .report-card-value.extra-size {
  font-size: 2rem;
}
.card-body .percentage-value {
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  color: #cccccc;
  font-size: 0.65rem;
}
.card-body ul {
  margin: 0;
  padding: 0;
}
.card-body ul li {
  list-style: none;
  padding: 0;
  font-size: 0.62rem;
  color: #7c828a;
}
.card {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/ReportCard.vue